import React from "react";

const FavoritesViewSkeleton = () => {
  return (
    <section className="flex w-full flex-col items-center gap-4">
      {/* <div className="flex w-full items-center justify-center">
        <div className="my-2 h-6 w-48 bg-gray-200"></div>
      </div> */}
      <div className="flex w-full flex-col items-center gap-6 bg-gray-100 p-8">
        {[...Array(5)].map((_, index) => (
          <div key={index} className="relative flex w-[881px] animate-pulse gap-4 bg-gray-200 p-4">
            <div className="absolute right-8 top-8 h-6 w-6 bg-gray-200"></div>
            <div className="h-44 w-[20%]">
              <div className="h-full bg-gray-100"></div>
            </div>
            <div className="h-60 w-[80%]">
              <div className="flex h-full flex-col bg-gray-100 p-4">
                <div className="my-2 h-4 w-1/3 bg-gray-200"></div>
                <div className="my-2 h-4 w-1/3 bg-gray-200"></div>
                <div className="my-2 h-4 w-1/3 bg-gray-200"></div>
                <div className="my-2 h-4 w-1/3 bg-gray-200"></div>
                <div className="my-2 h-4 w-1/3 bg-gray-200"></div>
                <div className="my-2 h-1 w-full bg-gray-200"></div>

                <div className="flex w-full items-center justify-between py-2">
                  <div className="h-4 w-1/3 bg-gray-200"></div>
                  <div className="h-10 w-1/3 bg-gray-200"></div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FavoritesViewSkeleton;
